/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ContractWorkUnit = {
    Daily: 'DAILY',
    Hourly: 'HOURLY'
} as const;
export type ContractWorkUnit = typeof ContractWorkUnit[keyof typeof ContractWorkUnit];


export function instanceOfContractWorkUnit(value: any): boolean {
    for (const key in ContractWorkUnit) {
        if (Object.prototype.hasOwnProperty.call(ContractWorkUnit, key)) {
            // @ts-ignore
            if (ContractWorkUnit[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ContractWorkUnitFromJSON(json: any): ContractWorkUnit {
    return ContractWorkUnitFromJSONTyped(json, false);
}

export function ContractWorkUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractWorkUnit {
    return json as ContractWorkUnit;
}

export function ContractWorkUnitToJSON(value?: ContractWorkUnit | null): any {
    return value as any;
}

